import { Box, BoxProps } from "@chakra-ui/react";

export function MailIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.58398 9.20898L10.7712 11.0934C12.6293 12.192 13.372 12.192 15.2301 11.0934L18.4173 9.20898"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.1831 14.5979C2.25392 17.9189 2.28933 19.5794 3.51472 20.8095C4.74011 22.0395 6.44554 22.0824 9.85641 22.1681C11.9586 22.2209 14.0401 22.2209 16.1423 22.1681C19.5532 22.0824 21.2586 22.0395 22.484 20.8095C23.7094 19.5794 23.7448 17.9189 23.8156 14.5979C23.8384 13.5301 23.8384 12.4686 23.8156 11.4008C23.7448 8.07978 23.7094 6.41928 22.484 5.18923C21.2586 3.95918 19.5532 3.91633 16.1423 3.83063C14.0401 3.77781 11.9586 3.77781 9.85641 3.83062C6.44554 3.91632 4.7401 3.95916 3.51471 5.18922C2.28932 6.41927 2.25391 8.07976 2.18309 11.4008C2.16032 12.4686 2.16032 13.5301 2.1831 14.5979Z"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
